// API MOCK -> TODO: AXIOS AND REAL API
const ConstructionsNames = new Promise((resolve, reject) => {
    const constructions = [
        {
            key: 1,
            value: 'Budowa 1',
            name: 'Budowa 1'
        },
        {
            key: 2,
            value: 'Budowa 2',
            name: 'Budowa 2'
        },
        {
            key: 3,
            value: 'Budowa 3',
            name: 'Budowa 3'
        },
        {
            key: 4,
            value: 'Budowa 5',
            name: 'Budowa 5'
        },
        {
            key: 5,
            value: 'Budowa 5',
            name: 'Budowa 5'
        },
    ];

    setTimeout(() => {
        resolve(constructions);
    }, 1000);
});

export {ConstructionsNames};
